import { API_URL, apiFetch } from '../../api';

/**
 * API för Årshjul (BL-195). Backend: backend/app/routers/arshjul.py.
 * Servern filtrerar bort datum användaren inte får se, så här görs inga
 * transformationer. 403 betyder att modulen inte är öppnad för användaren
 * och 404 att hjulet inte finns för hen. Båda ska tyst dölja vyn.
 */

const BAS = `${API_URL}/api/arshjul`;

export class ArshjulFel extends Error {
  constructor(meddelande, status) {
    super(meddelande);
    this.status = status;
  }
}

async function hamta(url) {
  const res = await apiFetch(url);
  if (!res.ok) {
    let detalj = 'Årshjulet kunde inte hämtas';
    try {
      const body = await res.json();
      if (body && typeof body.detail === 'string') detalj = body.detail;
    } catch { /* tomt svar */ }
    throw new ArshjulFel(detalj, res.status);
  }
  return res;
}

/** { hjul: [...] }. Tom lista betyder att widgeten inte ska visas. */
export async function hamtaWidget() {
  return (await hamta(`${BAS}/widget`)).json();
}

/** { hjul: [{ slug, namn, period_start, period_slut }] }, används av sök. */
export async function hamtaHjulLista() {
  return (await hamta(BAS)).json();
}

/** Hjulet och alla datum användaren får se. */
export async function hamtaHjul(slug) {
  return (await hamta(`${BAS}/${encodeURIComponent(slug)}`)).json();
}

/** Kalenderfilen som Blob. urval: 'mina' | 'alla'. kategori: 'af' | 'ovrigt' | null. */
export async function hamtaKalenderfil(slug, { urval = 'mina', kategori = null } = {}) {
  const q = new URLSearchParams({ urval });
  if (kategori) q.set('kategori', kategori);
  return (await hamta(`${BAS}/${encodeURIComponent(slug)}/ics?${q}`)).blob();
}
